import {
  addParameterList,
  getByKeyParameterList,
  removeParameterList,
  setParameterList,
  updateParameterList
} from "./system-parameter.action";
import {ISystemParameter} from "../models/system-parameter";

export interface ISystemParameterState {
  systemParameterList: ISystemParameter[];
  loading: boolean,
}

const initialState: ISystemParameterState = {
  systemParameterList: [],
  loading: false,
};

export function systemParameterReducer(state: ISystemParameterState = initialState, action: any) {
  switch (action.type) {
    case setParameterList:
      return {
        ...state,
        systemParameterList: action.payload,
      };
    case updateParameterList:
      return {
        ...state,
        systemParameterList: state.systemParameterList.map(t => t.id === action.payload.id ? action.payload : t),
      };
    case addParameterList:
      return {
        ...state,
        systemParameterList: [...state.systemParameterList, action.payload]
      };
    case removeParameterList:
      return {
        ...state,
        systemParameterList: state.systemParameterList.filter(t => t.id !== action.payload.parameter.id)
      };
    case getByKeyParameterList:
      return {
        ...state,
        systemParameterList: state.systemParameterList.filter(t => t.parameterGroup.tag == action.payload.groupKey && t.parameterKey == action.payload.parameterKey)
      };


    default:
      return state;
  }
}
